import { View } from "react-native";
import { NavigationMenuItem } from "../atoms/NavigationMenuItem";
import { useNavigationMenuFilter } from "../hooks/useNavigationMenuFilter";
import { Text } from "react-native";

export function NavigationMenu({ className }: { className?: string }) {
  const menuItemGroups = useNavigationMenuFilter();

  return (
    <View className={`px-8 pt-14 gap-10 min-w-[220px] ${className}`}>
      {menuItemGroups.map((group) => {
        const groupName = group[0]?.group || "";
        return (
          <View key={groupName || "main"} className={`gap-6`}>
            {groupName ? (
              <Text className="text-xs text-typography-800">{groupName}</Text>
            ) : null}
            {group?.map((item) => (
              <NavigationMenuItem
                key={item.path}
                icon={item.icon}
                label={item.label}
                path={item.path}
                active={item.active}
              />
            ))}
          </View>
        );
      })}
    </View>
  );
}
